import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
      },
    {
        title:Util.L('Code'),
        key:'code'
    },
    {
        title:Util.L('Type'),
        key:'refTypeName'
    },
    {
        title:Util.L('Status'),
        key:'statusName'
    },
    {
        title:Util.L('DeliveryPartner'),
        key:'deliveryPartnerName'
    },
    {
        title:Util.L('NumOfPackages'),
        key:'numOfPackages',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.numOfPackages));
        }
    },
    {
        title:Util.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    },
    {
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        width: 100
    }]